import { Option, SelectOption } from '@/components/form/types';
import { getIconForFieldType } from '@/explore/model/utils';
import { FieldGroup, isFieldGroup } from '@/explore/pipeline/utils';
import { Field } from '@/explore/types';

import { FieldOptionTooltip } from './field-option-tooltip';

export const createFieldOption = (field: Field): Option => {
  return {
    label: field.name,
    value: field.key,
    icon: getIconForFieldType(field.type),
    tooltip: <FieldOptionTooltip field={field} />,
  };
};

export const createFieldOptionGrouped = (fieldOrGroup: Field | FieldGroup): SelectOption => {
  if (isFieldGroup(fieldOrGroup)) {
    return {
      value: fieldOrGroup.key,
      label: fieldOrGroup.name ?? '',
      options: fieldOrGroup.fields.map(createFieldOption),
    };
  }
  return createFieldOption(fieldOrGroup);
};

export interface FieldOptionTooltipProps {
  field: Field;
}
